import { render } from "./jcalculator.vue?vue&type=template&id=37790c12"
import script from "./jcalculator.js?vue&type=script&lang=js"
export * from "./jcalculator.js?vue&type=script&lang=js"
script.render = render

export default script